import { useLazyQuery } from "@apollo/client"
import { DocumentNode } from "graphql"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { ErrorToast } from "utils/AppToaster"

interface RouteFormOptions {
  default?: any
  transform?: (state: any) => any
}

const useRouteForm = (query: DocumentNode, options?: RouteFormOptions) => {
  const { id } = useParams<{ id: string }>()

  // Its important to keep the empty object else the other modules will throw en error
  const [state, setState] = useState(options?.default ?? {})
  const [getDetails, { error, loading }] = useLazyQuery(query, {
    onCompleted(data) {
      const value = data?.[Object.keys(data)[0]]
      setState(options?.transform ? options?.transform?.(value) : value)
    },
    onError({ graphQLErrors }) {
      graphQLErrors.forEach(g => {
        ErrorToast(g.message)
      })
    },
  })

  useEffect(() => {
    if (parseInt(id)) {
      getDetails({ variables: { id } })
    }
  }, [id, getDetails])

  return [state, setState, { error, loading }]
}

export default useRouteForm
